import Khoi from "./Khoi"
export default Khoi